var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorPage',{attrs:{"title":"Votre session a expiré !","message":_vm.messageErreur,"image":"erreur-404.png","meta-title":"Erreur 401","meta-content":"Session expirée."}})}
var staticRenderFns = []

export { render, staticRenderFns }